import { Reducer } from 'redux'
import { createReducer } from 'reduxsauce'
import { IPatientState, PatientTypes } from './types'
import { IActionType, success, failure, request, IPaginator, ISearch } from '../root.types'
import { Patient } from '../../application/models/patient/patient'
import { ActiveSearchTypes } from '../active.search/types'
import { PotentialPatient } from '../../application/models/potential.patient/potentialPatient'

const INITIAL_STATE: IPatientState = {
    create: {
        avatar: {},
        patient: new Patient(),
        loading: false,
        success: false,
        error: false,
        loadingAvatar: false
    },
    list: {
        patients: [],
        loading: false,
        error: false,
        success: false,
        paginator: {
            first: 0,
            rows: 10,
            page: 0,
            pageCount: 0,
            totalRecords: 0,
            search: {
                key: '',
                value: ''
            }
        }
    }

}
// resetar paciente salvo no create
export const resetCreate = (state: IPatientState = INITIAL_STATE) => {
    const reset = {
        patient: new Patient(),
        loading: false,
        success: false,
        error: false
    }
    return {
        ...state,
        create: reset
    }
}

// resetar PAGINADOR salvo no LIST
export const resetPaginator = (state: IPatientState = INITIAL_STATE) => {
    const reset = {
        first: 0,
        rows: 10,
        page: 0,
        pageCount: 0,
        totalRecords: 0,
        search: {
            key: '',
            value: ''
        }

    }
    return {
        ...state,
        list: { ...state.list, paginator: reset }
    }
}

export const changeSearch = (
    state: IPatientState = INITIAL_STATE,
    action: IActionType<{ search: ISearch }>) => {
    const { search } = action.payload

    return {
        ...state,
        list: {
            ...state.list,
            paginator: {
                ...state.list.paginator,
                search
            }
        }
    }
}

// reducers para carregar listagem da tabela geral
export const loadPatients = (state: IPatientState = INITIAL_STATE, action: IActionType<{ paginator: IPaginator }>) => {
    const { paginator } = action.payload
    return { ...state, list: request({ ...state.list, paginator }) }
}

export const loadPatientSuccess = (
    state: IPatientState = INITIAL_STATE,
    action: IActionType<{ data: Patient[], headers: any }>) => {
    const { data, headers } = action.payload
    const paginator = {
        ...state.list.paginator,
        totalRecords: parseInt(headers['x-total-count'], 10)
    }
    return {
        ...state,
        list: success({ ...state.list, patients: data, paginator })
    }
}

export const loadPatientFailure = (state: IPatientState = INITIAL_STATE) => {
    return {
        ...state,
        list: failure(state.list)
    }
}

// reducers para procura paciente especifico
export const findPatientRequest = (state: IPatientState = INITIAL_STATE,
    action: IActionType<{ patientId: string }>) => {
    return { ...state, create: request({ ...state.create }) }
}
export const findPatientSuccess = (
    state: IPatientState = INITIAL_STATE,
    action: IActionType<{ data: Patient }>) => {
    const { data } = action.payload
    return {
        ...state,
        create: success({ ...state.create, patient: data })
    }
}

export const findPatientFailure = (state: IPatientState = INITIAL_STATE) => {
    return {
        ...state,
        create: failure(state.create)
    }
}

// reducers criar um paciente
export const createPatientRequest = (state: IPatientState = INITIAL_STATE,
    action: IActionType<{ patient: Patient }>) => {
    return { ...state, list: request({ ...state.list }) }
}
export const createPatientSuccess = (
    state: IPatientState = INITIAL_STATE,
    action: IActionType<{ data: Patient }>) => {
    const { data } = action.payload
    const updateList = [data].concat(state.list.patients)
    return {
        ...state,
        create: { ...state.create, patient: data },
        list: success({ ...state.list, patients: updateList })

    }
}

export const createPatientFailure = (state: IPatientState = INITIAL_STATE) => {
    return {
        ...state,
        list: failure(state.list)
    }
}
// reducers para atualizar dados do paciente 
export const updatePatientRequest = (state: IPatientState = INITIAL_STATE, action: IActionType<{ patient: Patient }>) => {
    return { ...state, create: request({ ...state.create }) }
}

export const updatePatientSuccess = (state: IPatientState = INITIAL_STATE,
    action: IActionType<{ data: Patient }>) => {
    const { data } = action.payload
    const updadedList = state.list.patients.map((patient) =>
        patient.id === data.id ? data : patient
    )
    return {
        ...state,
        create: success({ ...state.create, patient: data }),
        list: { ...state.list, patients: updadedList }
    }
}

export const updatePatientFailure = (state: IPatientState = INITIAL_STATE) => {
    return {
        ...state,
        create: failure(state.create)
    }
}

// reducers para avatar

export const changeAvatarFile = (state: IPatientState = INITIAL_STATE, action: IActionType<{ avatar: File }>) => {
    const { avatar } = action.payload
    return { ...state, create: { ...state.create, avatar: { ...state.create.avatar, file: avatar } } }
}

export const changeAvatarImg = (state: IPatientState = INITIAL_STATE, action: IActionType<{ avatar: any }>) => {
    const { avatar } = action.payload
    return { ...state, create: { ...state.create, avatar: { ...state.create.avatar, img: avatar } } }
}

export const loadAvatarRequest = (state: IPatientState = INITIAL_STATE) => {
    return { ...state, create: { ...state.create, loadingAvatar: false } }
}

export const loadAvatarSuccess = (state: IPatientState = INITIAL_STATE) => {
    return { ...state, create: { ...state.create, loadingAvatar: false } }
}

export const loadAvatarFailure = (state: IPatientState = INITIAL_STATE) => {
    return {
        ...state,
        create: {
            ...state.create,
            loadingAvatar: false,
            avatar: {
                file: '',
                img: ''
            }
        }
    }
}

export const removeAvatarRequest = (state: IPatientState = INITIAL_STATE) => {
    return { ...state, create: { ...state.create, loadingAvatar: true } }
}

export const removeAvatarSuccess = (state: IPatientState = INITIAL_STATE) => {
    return { ...state, create: { ...state.create, loadingAvatar: false, avatar: '' } }
}

export const removeAvatarFailure = (state: IPatientState = INITIAL_STATE) => {
    return { ...state, create: { ...state.create, loadingAvatar: false } }
}

export const handlePromoteRequest = (state: IPatientState = INITIAL_STATE,
    action: IActionType<{ activeSearch: PotentialPatient }>) => {
    return { ...state, create: request({ ...state.create }) }
}
export const handlePromoteSuccess = (
    state: IPatientState = INITIAL_STATE,
    action: IActionType<{ activeSearch: PotentialPatient }>) => {
    const { activeSearch } = action.payload
   
    const patient = new Patient().fromJSON({ ...activeSearch.toJSON() })

    return {
        ...state,
        create: success({ ...state.create, patient }),
    }
}
export const handlePromoteFailure = (state: IPatientState = INITIAL_STATE) => {
    return {
        ...state,
        create: failure(state.create)
    }
}


const reducer: Reducer<IPatientState> = createReducer<IPatientState>(INITIAL_STATE, {
    [PatientTypes.RESET_CREATE]: resetCreate,
    [PatientTypes.RESET_PAGINATOR]: resetPaginator,
    [PatientTypes.CHANGE_SEARCH]: changeSearch,

    [PatientTypes.LOAD_PATIENT_REQUEST]: loadPatients,
    [PatientTypes.LOAD_PATIENT_SUCCESS]: loadPatientSuccess,
    [PatientTypes.LOAD_PATIENT_FAILURE]: loadPatientFailure,

    [PatientTypes.FIND_PATIENT_REQUEST]: findPatientRequest,
    [PatientTypes.FIND_PATIENT_SUCCESS]: findPatientSuccess,
    [PatientTypes.FIND_PATIENT_FAILURE]: findPatientFailure,

    [PatientTypes.CREATE_PATIENT_REQUEST]: createPatientRequest,
    [PatientTypes.CREATE_PATIENT_SUCCESS]: createPatientSuccess,
    [PatientTypes.CREATE_PATIENT_FAILURE]: createPatientFailure,

    [PatientTypes.UPDATE_PATIENT_REQUEST]: updatePatientRequest,
    [PatientTypes.UPDATE_PATIENT_SUCCESS]: updatePatientSuccess,
    [PatientTypes.UPDATE_PATIENT_FAILURE]: updatePatientFailure,


    [PatientTypes.CHANGE_AVATAR_FILE]: changeAvatarFile,
    [PatientTypes.CHANGE_AVATAR_IMG]: changeAvatarImg,

    [PatientTypes.LOAD_AVATAR_REQUEST]: loadAvatarRequest,
    [PatientTypes.LOAD_AVATAR_SUCCESS]: loadAvatarSuccess,
    [PatientTypes.LOAD_AVATAR_FAILURE]: loadAvatarFailure,

    [PatientTypes.REMOVE_AVATAR_REQUEST]: removeAvatarRequest,
    [PatientTypes.REMOVE_AVATAR_SUCCESS]: removeAvatarSuccess,
    [PatientTypes.REMOVE_AVATAR_FAILURE]: removeAvatarFailure,

    [ActiveSearchTypes.HANDLE_PROMOTE_REQUEST]: handlePromoteRequest,
    [ActiveSearchTypes.HANDLE_PROMOTE_SUCCESS]: handlePromoteSuccess,
    [ActiveSearchTypes.HANDLE_PROMOTE_FAILURE]: handlePromoteFailure,
})
export default reducer